import { memo } from 'react';

function ConsentIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.6658 10H12.3325M7.6658 13.1111H12.3325M13.888 17H6.11024C5.25113 17 4.55469 16.3036 4.55469 15.4444V4.55556C4.55469 3.69645 5.25113 3 6.11024 3H10.4547C10.661 3 10.8589 3.08194 11.0047 3.22781L15.2158 7.43886C15.3616 7.58472 15.4436 7.78255 15.4436 7.98883V15.4444C15.4436 16.3036 14.7471 17 13.888 17Z"
        stroke="#6B7280"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(ConsentIcon);
